/**
 * Identité du déclarant, persistée localement (pas de compte).
 * Reprend les champs OSER du service `Report` / écran profil.
 */
export interface Profile {
  subsidiary_id: number | null;
  person_status: string | null;
  firstname: string;
  lastname: string;
  email: string;
  phone: string;
}

// Statuts du déclarant (mêmes clés qu'OSER — i18n entities.person_status.*).
export const PERSON_STATUSES = ['EMPLOYEE', 'CONTRACTOR', 'THIRD_PARTY', 'TRANSPORTER'] as const;
export type PersonStatus = (typeof PERSON_STATUSES)[number];

export const EMPTY_PROFILE: Profile = {
  subsidiary_id: null,
  person_status: null,
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
};
